export default __webpack_public_path__ + "static/allendai_resume-38f7b1bbed9d9025a6c39f179369a028.pdf";